import { render, staticRenderFns } from "./subspecializations.vue?vue&type=template&id=a705a432&"
import script from "./subspecializations.vue?vue&type=script&lang=js&"
export * from "./subspecializations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports